export default __webpack_public_path__ + "static/media/fallout-mutation-to.be6804b7.png";